import { render, staticRenderFns } from "./TdOrgUsertree.vue?vue&type=template&id=c563957e&"
import script from "./TdOrgUsertree.vue?vue&type=script&lang=js&"
export * from "./TdOrgUsertree.vue?vue&type=script&lang=js&"
import style0 from "./TdOrgUsertree.vue?vue&type=style&index=0&id=c563957e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports